$(function() {
    const e = $(".btn-copy");
    e.on("click", function(e) {
        e.preventDefault();
        const t = $(this).attr("data-prepend-text") + $('input[name="' + $(this).attr("data-field") + '"]').val();
        let a = $("<input>");
        $("body").append(a);
        a.val(t).select();
        document.execCommand("copy");
        a.remove();
        $(this).tooltip("hide").attr("data-original-title", "Copied!").tooltip("show");
    });
    e.on("mouseout", function(e) {
        $(this).attr("data-original-title", "Copy url to clipboard").tooltip("hide");
    });
});

$(function() {
    $("#newAppStep1").on("click", () => {
        $("#newAppStep1").attr("disabled", true);
        $.post("/admin/apps", {
            ajax: 1,
            storelink: $("#addAppStore").val()
        }, function(e, t, a) {
            if (a) $("#newAppStep1").attr("disabled", false);
            if (!a) swal("Ho no!", "Something went wrong with that data post", "error");
            if (a.status === 200 && e.success && e.app) {
                appStoreComplete(e.app);
            } else if (a.status === 200 && e.message) swal("Ooops!", e.message, "warning"); else if (a.status === 200) swal("Ooops!", "This came back and wasn't expected: " + e, "error"); else swal("Ho no!", "A status code of " + a.status + " was returned. This wasn't expected.", "error");
        });
    });
    $("#newAppStep2").on("click", () => {
        let e = {
            newfile: true
        };
        $("#newAppStep2").attr("disabled", true);
        $("#frmNewApp").serializeArray().forEach(t => {
            if (e[t.name]) {
                if (Array.isArray(e[t.name])) e[t.name].push(t.value); else e[t.name] = [ e[t.name], t.value ];
            } else e[t.name] = t.value;
        });
        $.post("/admin/apps", e, function(e, t, a) {
            if (t === "success" && e.success) {
                swal({
                    title: "Success",
                    text: e.text || +"Your app has been added as a new app",
                    icon: "success"
                }).then(function() {
                    location.reload();
                });
            } else {
                $("#newAppStep2").attr("disabled", false);
                swal({
                    title: "Error",
                    text: e.text || +"There was an issue with the app processing",
                    icon: "error"
                });
            }
        });
    });
});

function showAddNew() {
    $("#addAppStore").val("");
    $("#newAppDialog").modal();
    $("#newAppPage1").show();
    $("#newAppPage2").hide();
}

function addAppUploadComplete(e, t) {
    Dropzone.forElement("#addFileDz").removeAllFiles(true);
    if (!t) swal("Oh no!", "Something went wrong with that upload", "error"); else if (t.simple) {
        $("#newAppTitle2").html((t.simple.name || "App") + (t.simple.existingVer ? ": update" : ": new app"));
        $("#frmNewApp input[name=file]").val(t.file);
        $("#frmNewApp input[name=store_id]").val("");
        $("#frmNewApp input[name=name]").removeAttr("readonly").val(t.simple.name);
        $("#frmNewApp input[name=version]").removeAttr("readonly").val(t.simple.version);
        $("#frmNewApp textarea[name=desc]").removeAttr("readonly").val(t.simple.description || "");
        $("#frmNewApp input[name=shortdesc]").removeAttr("readonly").val(t.simple.shortdesc || "");
        if (t.simple.existingVer) {
            $("#frmNewApp textarea[name=whatsnew]").val("");
            $("#newAppWhatsNew").show();
            $("#newAppPreviousVersionText").html("v. " + t.simple.existingVer);
            $("#newAppShortDesc").hide();
            $("#newAppDesc").hide();
        } else {
            $("#newAppWhatsNew").hide();
            $("#newAppPreviousVersion").hide();
            $("#newAppShortDesc").show();
            $("#newAppDesc").show();
        }
        var a = "";
        if (t.appstores && t.appstores.length) {
            t.appstores.forEach(function(e) {
                a += '<input type="checkbox" name="stores" value="' + e.id + '" ' + (e.linked ? "checked" : "") + "> " + e.name + "<br>";
            });
            $("#newAppAppStoresList").html(a);
            $("#newAppAppStores").show();
        } else {
            $("#newAppAppStoresList").html("");
            $("#newAppAppStores").hide();
        }
        $("#frmNewApp input[name=type]").val(t.type);
        $("#newAppPage2").show();
        $("#newAppPage1").hide();
        $("#frmNewApp textarea[name=desc]").focus();
        $("#modal-img").show().attr("src", "/public/tmp/" + t.icon);
    } else swal("Ooops!", t.message || t.error || "This came back and wasn't expected: " + t, "error");
}

function appStoreComplete(e) {
    $("#newAppTitle2").html(e.name || "App");
    $("#frmNewApp input[name=store_id]").val(e.store_id);
    $("#frmNewApp input[name=type]").val(e.platform);
    $("#frmNewApp input[name=file]").val(e.file);
    $("#frmNewApp input[name=name]").attr("readonly", "readonly").val(e.name);
    $("#frmNewApp input[name=version]").attr("readonly", "readonly").val(e.version);
    $("#frmNewApp textarea[name=desc]").attr("readonly", "readonly").val(e.description || "");
    $("#frmNewApp input[name=shortdesc]").val(e.shortdesc || "");
    $("#frmNewApp textarea[name=whatsnew]").attr("readonly", "readonly").val(e.whatsnew);
    $("#newAppWhatsNew").show();
    $("#newAppPreviousVersion").hide();
    $("#newAppShortDesc").show();
    $("#newAppDesc").show();
    var t = "";
    if (e.appstores && e.appstores.length) {
        e.appstores.forEach(function(e) {
            t += '<input type="checkbox" name="stores" value="' + e.id + '" ' + (e.linked ? "checked" : "") + "> " + e.name + "<br>";
        });
        $("#newAppAppStoresList").html(t);
        $("#newAppAppStores").show();
    } else {
        $("#newAppAppStoresList").html("");
        $("#newAppAppStores").hide();
    }
    $("#newAppPage2").show();
    $("#newAppPage1").hide();
    setTimeout(() => $("#modal-img").show().attr("src", "/public/images/" + e.file + ".png"), 500);
}

$(function() {
    $("#addFileDz").dropzone({
        url: "/admin/apps",
        maxFiles: 1,
        dictDefaultMessage: "Drop ipa/apk to upload",
        uploadMultiple: false,
        addRemoveLinks: true,
        timeout: 3e5,
        acceptedFiles: ".ipa,.apk",
        success: addAppUploadComplete
    });
});

$(function() {
    let e = $("#country");
    e.on("change", shouldShowVat);
    shouldShowVat();
    $("form.account-form").submit(function(e) {
        e.preventDefault();
        $.post("/admin/account", $(this).serializeArray(), function(e) {
            if (e.status === "OK") {
                swal("", "", "success").then(function() {
                    location.reload();
                });
            } else if (e.status === "error") swal({
                title: "Error",
                text: e.message || "Your changes were not saved.",
                icon: "error"
            });
        });
    });
});

function shouldShowVat() {
    let e = $("#country");
    let t = $("#input-vat");
    if (e.find(":selected").data("tax") !== 0) t.prop("disabled", false); else {
        t.val("");
        t.prop("disabled", true);
    }
}

$(function() {
    const e = $("#frmApp");
    const t = e.data("url-base");
    const a = e.data("app-id");
    const n = `${t}/apps/${a}`;
    e.on("submit", t => {
        t.preventDefault();
        $.post(n, e.serialize(), (e, t) => {
            if (e && e.success) swal({
                title: "Success",
                text: e.message,
                icon: "success"
            }).then(() => {
                document.location = n;
            }); else swal({
                title: "Error",
                text: e.message || "Your changes were not saved.",
                icon: "error"
            });
        });
    });
    $(".btn-app-version-delete").on("click", function() {
        const e = $(this).data("version-id");
        swal({
            title: "Delete",
            text: "Are you sure?",
            icon: "warning",
            buttons: [ "Cancel", "Yes" ]
        }).then(t => {
            if (!t) return;
            $.post(n, {
                deleteversion: e
            }, (e, t) => {
                if (e.status === "OK") document.location = n; else swal({
                    title: "Error",
                    text: e.message || "Your changes were not saved.",
                    icon: "error"
                });
            });
        });
    });
    $(".btn-app-delete").on("click", () => {
        swal({
            title: "Delete App",
            text: "Are you sure?",
            icon: "warning",
            buttons: [ "Cancel", "Yes" ]
        }).then(e => {
            if (!e) return;
            $.post(n, {
                deleteapp: 1
            }, (e, a) => {
                if (e.status === "OK") document.location = `${t}/apps`; else swal({
                    title: "Error",
                    text: e.message || "Your changes were not saved.",
                    icon: "error"
                });
            });
        });
    });
    $("#passwordBtnShow").on("click", function(e) {
        e.preventDefault();
        const t = $("input[name=passwordchange]");
        const a = t.attr("type");
        t.attr("type", a === "password" ? "text" : "password");
        if (a === "password") $("#pwBtnText").text("Hide"); else $("#pwBtnText").text("Show");
        $(this).blur();
    });
});

$(function() {
    const e = $(".app-card-container");
    $(".btn-app-filter").on("click", function() {
        let t = $("#appCardsContainer");
        t.html(e);
        $(".btn-app-filter").removeClass("active");
        $(this).addClass("active");
        let a = $(this).data("platform");
        if (a === "all") return t.html(e);
        let n = $(`.platform-${a}`);
        t.html(n);
    });
    const t = new Tour({
        name: "tour",
        steps: [ {
            orphan: true,
            title: "Lets get started!",
            content: "Thanks for choosing YourAppBox (YAB). We have a super short tour to show you the basics.",
            backdrop: true
        }, {
            element: "#sideNavUserDataContainer",
            title: "User Profile",
            content: 'On the "My Account" page, you can set your personal details, including company name, profile picture, VAT number and more.',
            placement: "right",
            backdrop: true
        }, {
            element: "#sidebarAddApp",
            title: "Add Apps",
            content: "You can add new apps at any point from here.",
            placement: "right",
            backdrop: true
        }, {
            element: "#sidebarLinks",
            title: "Add App Stores",
            content: "Be sure to check out your menu options, especially App Store. App Stores allow you to group apps together and manage them in different ways. Get started by creating your first store, you can add and remove apps at any time.",
            placement: "right",
            backdrop: true
        }, {
            element: "#btnSignup",
            title: "Sign up",
            content: "If you love using YAB, you can click here to enter payment details and continue using the platform after your trial.",
            placement: "left",
            backdrop: true
        }, {
            element: "#btnGettingStarted",
            title: "Get Started!",
            content: "That's it! click to end the tour then click this button to add your first app!",
            placement: "bottom",
            backdrop: true
        } ],
        container: "body",
        smartPlacement: true,
        keyboard: true,
        storage: window.localStorage,
        debug: false,
        backdrop: false,
        backdropContainer: "body",
        backdropPadding: 0,
        redirect: true,
        orphan: false,
        duration: false,
        delay: false,
        basePath: "",
        afterGetState: function(e, t) {},
        afterSetState: function(e, t) {},
        afterRemoveState: function(e, t) {},
        onStart: function(e) {},
        onEnd: function(e) {
            $.post("/api/user/tour-complete");
        },
        onShow: function(e) {},
        onShown: function(e) {},
        onHide: function(e) {},
        onHidden: function(e) {},
        onNext: function(e) {},
        onPrev: function(e) {},
        onPause: function(e, t) {},
        onResume: function(e, t) {},
        onRedirectError: function(e) {}
    });
    t.init();
    const a = $("#tourComplete");
    if (a.length) {
        const e = a.val();
        if (!e) t.start();
    }
});

$(function() {
    if (window.location.pathname.indexOf("/appstores") !== -1) {
        $("#btnSaveStore").on("click", function(e) {
            var t = $(this);
            t.attr("disabled", true);
            let a = validateDiv("#appStoreDetails", true);
            if (!a) {
                t.attr("disabled", false);
                return;
            }
            const n = $("#frmAppStore").serializeArray();
            const o = $(".app-store__app-card.active").map((e, t) => $(t).data("app-id")).toArray().join(",");
            n.push({
                name: "apps",
                value: o
            });
            $.post(`/admin/appstores/${$("#storeId").val()}`, n, function(e, a) {
                if (e && e.success) {
                    swal({
                        title: "Success",
                        text: e.message,
                        icon: "success"
                    }).then(function() {
                        document.location = "/admin/appstores";
                    });
                } else {
                    t.attr("disabled", false);
                    swal({
                        title: "Error",
                        text: e.message || "Your changes were not saved.",
                        icon: "error"
                    });
                }
            });
        });
        $("#btnDeleteStore").on("click", function(e) {
            e.preventDefault();
            $(this).attr("disabled", true);
            var t = $(this);
            swal({
                title: "Delete Store",
                text: "Are you sure?",
                icon: "warning",
                buttons: [ "Cancel", "Yes" ]
            }).then(function(e) {
                if (e) {
                    $.post("/admin/appstores", {
                        deleteId: $("#storeId").val()
                    }, function(e, t) {
                        document.location = "/admin/appstores";
                    });
                } else t.attr("disabled", false);
            });
        });
        $(".app-store__app-card").on("click", function(e) {
            $(this).toggleClass("active");
            countApps();
        });
        $("select[name=security]").on("change", checkPasswordVisible);
        countApps();
        checkPasswordVisible();
    }
});

function countApps() {
    const e = $(".app-store__app-card.active").length;
    $("a.appslink").text("Apps (" + e + ")");
}

function checkPasswordVisible() {
    if ($("select[name=security]").val() === "password") $("#passwordField").show(); else $("#passwordField").hide();
}

$(function() {
    let e = $("#frmForgotPw");
    const t = $("#btnForgotPw");
    e.on("submit", a => {
        a.preventDefault();
        t.attr("disabled", true);
        let n = e.serialize();
        $.ajax({
            type: "POST",
            data: n,
            dataType: "json",
            success: function(e) {
                if (e.control === true) swal("You will receive a reset link via email shortly."); else {
                    t.attr("disabled", false);
                    swal("", e.message, "warning");
                }
            },
            error: function(e) {
                t.attr("disabled", false);
                swal("", "Something went wrong on our side, please try again or contact us if it persists.", "error");
            }
        });
    });
});

$(function() {
    let e = $("#frmLogin");
    e.on("submit", t => {
        t.preventDefault();
        let a = e.serialize();
        $.ajax({
            type: "POST",
            data: a,
            dataType: "json",
            success: function(e) {
                if (e.control === true) location.reload(); else swal("", e.message, "warning");
            },
            error: function(e) {
                swal("", "Something went wrong on our side, please try again or contact us if it persists.", "error");
            }
        });
    });
});

$(function() {
    if (window.location.pathname.indexOf("register") !== -1) {
        let e = $("#country");
        shouldRegisterShowVat();
        e.on("change", shouldRegisterShowVat);
        let t = $("#frmRegister");
        const a = $("#btnRegister");
        t.on("submit", function(e) {
            e.preventDefault();
            a.attr("disabled", true);
            if (!$("#terms").hasClass("checked")) {
                a.attr("disabled", false);
                return swal("", "You must accept the terms and conditions.", "warning");
            }
            let n = t.serialize();
            if ($("#marketing").hasClass("checked")) n += "&marketing=true";
            $.ajax({
                type: "POST",
                data: n,
                dataType: "json",
                success: function(e) {
                    if (e.control === true) swal("", e.message, "success").then(e => {
                        window.location = "/admin/login";
                    }); else {
                        a.attr("disabled", false);
                        swal("", e.message, "error");
                    }
                },
                error: function(e) {
                    a.attr("disabled", false);
                    swal("", "Something went wrong on our side, please try again or contact us if it persists.", "error");
                }
            });
        });
    }
});

function shouldRegisterShowVat() {
    let e = $("#country");
    let t = $("#vat");
    let a = $("#vat-form-group");
    if (e.find(":selected").data("tax") !== 0) {
        t.prop("disabled", false);
        a.removeClass("disabled");
    } else {
        t.val("");
        t.prop("disabled", true);
        a.addClass("disabled");
    }
}

$(function() {
    let e = $("#frmSetPw");
    e.on("submit", t => {
        t.preventDefault();
        let a = e.serialize();
        $.ajax({
            type: "POST",
            data: a,
            dataType: "json",
            success: function(e) {
                if (e.control === true) swal("Your password has been reset.").then(() => {
                    window.location = "/admin/login";
                }); else swal("", e.message, "warning");
            },
            error: function(e) {
                swal("", "Something went wrong on our side, please try again or contact us if it persists.", "error");
            }
        });
    });
});

$(function() {
    const e = $("#frmSupport");
    const t = $("#frmSupportSubmit");
    e.submit(function(a) {
        a.preventDefault();
        t.attr("disabled", true);
        $.ajax({
            url: "/api/mail",
            type: "POST",
            dataType: "json",
            data: e.serialize(),
            success: function(e) {
                t.attr("disabled", false);
                if (e.control === true) swal("", "Thanks we will be in touch asap. ", "success"); else swal("", e.message, "warning");
            },
            error: function(e) {
                t.attr("disabled", false);
                swal("", "Sorry we could not send your email at this time. Contact us directly at support@yourappbox.com", "error");
            }
        });
    });
});

if (typeof Dropzone !== "undefined") Dropzone.autoDiscover = false;

$(function() {
    const e = $(".limited-textarea");
    e.each(function() {
        setCharCount($(this), false);
    });
    e.on("keyup", function() {
        setCharCount($(this));
    });
    $("#apiKeyRegen").on("click", async e => {
        swal({
            title: "Are you sure?",
            text: "Once regenerated all existing applications using this key will not longer be able to communicate with YourAppBox.",
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then(e => {
            if (e) {
                $.ajax({
                    url: "api/random-api-key",
                    type: "GET",
                    dataType: "json"
                }).done(function(e) {
                    $("#api_key").val(e);
                }).fail(function(e) {
                    swal("", "Sorry, there was a problem regenerating your API key", "error");
                });
            }
        });
    });
    const t = $("#sideNavContainer");
    const a = $("#sideNavToggle");
    a.on("click", function() {
        t.toggleClass("open");
        $("body").toggleClass("no-scroll");
        $(".nav-btn__top").toggleClass("open");
        $(".nav-btn__middle").toggleClass("open");
        $(".nav-btn__bottom").toggleClass("open");
    });
    $(".data-table").DataTable({
        paging: false,
        ordering: true,
        info: false,
        searching: false
    });
    $("input").on("focus", function() {
        $(this).removeClass("invalid");
    });
    $('[data-toggle="tooltip"]').tooltip();
    $(".checkbox").on("click", function() {
        $(this).toggleClass("checked");
        if ($(this).data("input")) {
            var e = $(this).hasClass("checked") ? "1" : "";
            $('input[name="' + $(this).data("input") + '"]').val(e);
        }
    });
    $(function() {
        $(".btn-add-app").on("click", function() {
            showAddNew();
        });
    });
});

function validateDiv(e, t) {
    var a = true;
    $(e).find("input").each(function() {
        var e = $(this).attr("validate");
        if (e && !$(this).hasClass("disabled")) {
            var n = $(this).val() || "";
            var o = new RegExp(e);
            if (!o.test(n)) {
                a = false;
                if (t) {
                    var s = $(this).offset();
                    if (s && s.top) $("html, body").animate({
                        scrollTop: s.top - 200
                    }, 200);
                    t = false;
                }
                $(this).addClass("invalid");
                $(this).next(".validateText").show();
            }
        }
    });
    return a;
}

function setCharCount(e, t = true) {
    const a = e.val().length;
    const n = e.attr("maxlength");
    const o = e.parent().find(".char-count").eq(0);
    e.parent().find(".char-limit").eq(0).text(n);
    o.text(a);
    if (a >= n && t) swal(`You can only use ${n} characters`);
}